function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { getGlobalLapel, isDebugging } from "../utils/debug";
import { EventNames } from "./events";
import logger, { LapelError } from "../logger";
var AnalyticsSingleton = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsSingleton() {
        this.EventNames = EventNames;
        if (!AnalyticsSingleton.instance) {
            AnalyticsSingleton.instance = this;
        }
        this.events = [];
        this.receivers = [];
        return AnalyticsSingleton.instance;
    }
    var _proto = AnalyticsSingleton.prototype;
    _proto.addReceiver = function addReceiver() {
        for(var _len = arguments.length, receivers = new Array(_len), _key = 0; _key < _len; _key++){
            receivers[_key] = arguments[_key];
        }
        var _this_receivers;
        (_this_receivers = this.receivers).push.apply(_this_receivers, _to_consumable_array(receivers));
    };
    _proto.removeReceiver = function removeReceiver() {
        for(var _len = arguments.length, receivers = new Array(_len), _key = 0; _key < _len; _key++){
            receivers[_key] = arguments[_key];
        }
        var _this = this;
        // Singletons are frozen so we must modify the array in place
        receivers.forEach(function(receiver) {
            var index = _this.receivers.indexOf(receiver);
            if (index > -1) {
                _this.receivers.splice(index, 1);
            }
        });
    };
    _proto.track = function track(name, value) {
        if (value === void 0) value = true;
        if (!name) {
            var err = new LapelError("AnalyticsSingleton.track called with no name");
            logger.error(err);
            return Promise.allSettled([
                Promise.reject(err)
            ]);
        }
        var lapelEvent = {
            name: name,
            value: value
        };
        if (isDebugging()) {
            this.events.push(lapelEvent);
        }
        return Promise.allSettled(this.receivers.map(function(receiver) {
            try {
                return receiver(lapelEvent);
            } catch (e) {
                return Promise.reject(e);
            }
        }));
    };
    return AnalyticsSingleton;
}();
var analyticsInstance = new AnalyticsSingleton();
Object.freeze(analyticsInstance);
(function() {
    var lapelGlobal = getGlobalLapel();
    if (lapelGlobal) {
        lapelGlobal.analytics = analyticsInstance;
    }
})();
export default analyticsInstance;

//# sourceMappingURL=AnalyticsSingleton.js.map